import { render, staticRenderFns } from "./ModalAdicionarPrecos.vue?vue&type=template&id=88ce42ee&"
import script from "./ModalAdicionarPrecos.vue?vue&type=script&lang=js&"
export * from "./ModalAdicionarPrecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports